enum WidgetType {
  activity = 'activity',
  alarmInformations = 'alarm-informations',
  countdown = 'countdown',
  crewtarget = 'crewtarget',
  directMessages = 'direct-messages',
  dragDropIndicator = 'drag-drop-indicator',
  header = 'header-widget',
  iframe = 'iframe-widget',
  map = 'map-widget',
  messages = 'messages-widget',
  messenger = 'messenger',
  report = 'report',
  spacer = 'spacer',
  statusCompact = 'status-compact',
  statusDetail = 'status-detail',
  vehicleStatus = 'vehicle-status',
  vehicleStatusHistory = 'vehicle-status-history',
  widgetContainer = 'widget-container'
}

enum WidgetHeightType {
  automatic = 'automatic',
  grid = 'grid',
  percentage = 'percentage',
  pixel = 'pixel',
  remaining = 'remaining'
}

export { WidgetHeightType, WidgetType }
